// import { Dialog } from "@mui/material";
import { 
  AddKitchenForm, AddMemberForm, DeleteConfirmationForm, 
  AddPlanForm, AddCredentialForm, 
  AddRequirementForm, NewMessageForm, AddFeeForm, 
  AddDiscountForm, InviteTeamMemberForm, EditPlanForm } from "./forms";
// import KitchenDetails from "../molecules/KitchenDetails";
import MemberDetails from "./MemberDetails"
import CredentialPreview from "./CredentialPreview"
// import CredentialDetails from "./CredentialDetails"

import LoadingScreen from "../pages/shared/LoadingScreen"

// import { deleteKitchen } from "../api/crud";
// import { useAuthState } from "../contexts/authcontext";
import { useKitchenHook, useResourceHook, useLoadResourceOptions } from "../hooks/resourcehooks";
import { useAddCommunityPlan } from "../hooks/communityhook";

import { DSCommunitySchema, ResourcePlanSchema, PlanSchema, CredentialSchema, RequirementSchema, KitchenSpaceSchema, InventorySchema, ResourceType, ResourceSchema, TrainingInventorySchema, MembershipSchema, SelfServiceDetailsSchema, ResourceBookingSchema, FeeSchema, DiscountSchema, CurrentRequirementsSchema } from "../data/types";
import AddResourceForm from "./forms/AddResourceForm";
import { AddProductForm, UpdateProductForm } from "./forms/AddProductForm";
import { CalendarToday, Cancel, CheckCircle } from "@mui/icons-material";
import { X } from "lucide-react";
import { capitalizeWords } from "../utils/helpers";
import SelfServiceRegistrationForm from "../molecules/forms/SelfServiceRegistrationForm";
// import { useState } from "react";
import { useCallback, useEffect, type FC, type ReactNode } from "react";
import { createPortal } from "react-dom";
// import { useResourceState } from "../contexts/kitchencontext";
// import { usePreferences } from "../contexts/preferencecontext";
import NewSelfServiceForm from "../molecules/forms/NewSelfServiceForm";
import EditSelfServiceForm from './forms/EditSelfServiceForm';
import RequestDetails from "../molecules/RequestDetails";
import { AddResourcePlanForm, AddReservationForm, EditResourcePlanForm } from "./forms";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "../contexts/authcontext";
import { useGetConnectedAccount } from "../hooks/paymenthooks";
import InventoryItemDetails from "./InventoryItemDetails";

type ModalProps = {
  isOpen: boolean;
};

type PortalDialogShellProps = {
  isOpen: boolean
  testId: string
  labelledBy?: string
  onClose: () => void
  children: ReactNode
  panelClassName?: string
};

/** Viewport-centered dialog portaled to document.body so overflow/transform parents cannot clip it. */
export const PortalDialogShell: FC<PortalDialogShellProps> = ({
  isOpen,
  testId,
  labelledBy,
  onClose,
  children,
  panelClassName = 'w-full max-w-lg md:max-w-2xl max-h-[90vh]',
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen || typeof document === 'undefined') return null;

  return createPortal(
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6">
      <div className="fixed inset-0 bg-[#013847]/50" onClick={onClose} />
      <dialog
        data-testid={testId}
        className={`relative z-[100] ${panelClassName} overflow-hidden rounded-xl bg-white shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] flex flex-col`}
        open={isOpen}
        aria-labelledby={labelledBy}
        onClose={onClose}
        style={{ margin: 0 }}
      >
        {children}
      </dialog>
    </div>,
    document.body,
  );
};



type AddSelfServicePartnerModalProps = ModalProps & {
  selfServiceDetails: SelfServiceDetailsSchema;
  isLoggedIn: boolean;
  closeAppModal: () => void;
};

export const AddSelfServicePartnerModal: React.FC<AddSelfServicePartnerModalProps> = (props) => {
  let { isOpen, selfServiceDetails, isLoggedIn, closeAppModal } = props

  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="add-custom-requirement"
        className="z-50 w-full max-w-lg md:max-w-2xl max-h-[95vh] bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
        <div className="overflow-y-auto flex-1 p-4">
          <div className="w-full max-w-2xl mx-auto p-4">
              <span onClick={closeAppModal} className="ml-auto w-full flex cursor-pointer">
                  <Cancel className="text-[#A1A1A1] hover:text-[#777] h-[18px] w-[18px] ml-auto" />
              </span>
              <h2 className="text-center text-xl font-semibold text-primary-200 font-raleway">
                Partner Registration
              </h2>
              <p className="mb-2 text-center text-sm text-back-200 font-open-sans">
                Complete registration for {selfServiceDetails?.name || 'the venue'}
              </p>
              <SelfServiceRegistrationForm selfServiceDetails={selfServiceDetails} isLoggedIn={isLoggedIn} closeAppModal={closeAppModal} />
          </div>
        </div>
      </dialog>
    </div>
  );
};


type MemberDetailsModalProps = ModalProps & {
  closeAppModal: () => void;
  member: MembershipSchema
}

export const MemberDetailsModal: React.FC<MemberDetailsModalProps> = (props) => {
  var { isOpen, member, closeAppModal } = props

  return (
    <PortalDialogShell isOpen={isOpen} testId="view-member-modal" onClose={closeAppModal}>
      <div className="overflow-y-auto flex-1 p-4">
        <MemberDetails member={member} handleClose={closeAppModal} />
      </div>
    </PortalDialogShell>
  );
}


type MemberAgreementPreviewModalProps = ModalProps & {
  closeAppModal: () => void;
  credential: CurrentRequirementsSchema | null;
};

export const MemberAgreementPreviewModal: React.FC<MemberAgreementPreviewModalProps> = (props) => {
  const { isOpen, credential, closeAppModal } = props;

  if (!credential) return null;

  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="member-agreement-preview-modal"
        className="z-50 w-full max-w-4xl max-h-[95vh] bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
        <div className="overflow-y-auto flex-1 p-4">
          <CredentialPreview
            credential={credential}
            handleClose={closeAppModal}
            onApprove={closeAppModal}
            onReject={closeAppModal}
            onCancel={closeAppModal}
          />
        </div>
      </dialog>
    </div>
  );
};


type AddCredentialModalProps = ModalProps & {
  closeAppModal: () => void;
  handleSubmitCredential: (credential: CredentialSchema) => void
}

const AddCredentialModal: React.FC<AddCredentialModalProps> = (props) => {
  var { isOpen, handleSubmitCredential, closeAppModal } = props

  return (
    <div
      className={`inset-0 ${isOpen ? "block" : "hidden"}`}
    >
      <div className="fixed inset-0 bg-white opacity-90" onClick={() => closeAppModal()}></div>

      <dialog
        data-testid="add-credential-modal"
        className="z-50 top-20 bg-[#EEE] p-4 rounded-md shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] md:w-1/2"
        open={isOpen}
        onClose={() => closeAppModal()}
      >
        <AddCredentialForm handleSubmitCredential={handleSubmitCredential} handleClose={closeAppModal} />
      </dialog>
    </div>
  );
}


type AddKitchenModalProps = ModalProps & {
  closeAppModal: () => void;
};


const DefaultModal: React.FC<AddKitchenModalProps> = (props) => {
  var { isOpen, closeAppModal } = props
  const { isLoading, addKitchenSpace } =  useKitchenHook()
  if (isLoading){
    return (
      <LoadingScreen />
    )
  }
  

  const handleAddKitchen = (kitchen: KitchenSpaceSchema | {}) => {
    addKitchenSpace(kitchen)
    closeAppModal();
  }

  return (
    <div
      className={` inset-0 ${isOpen ? "block" : "hidden"} max-w-full`}
    >
      <div className="bg-white opacity-90 absolute inset-0 w-full max-h-full"></div>

      <dialog
        data-testid="add-kitchen-modal"
        className="z-50 bg-white p-4 rounded-md shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] md:w-[1158px] w-full max-w-screen-md"
        open={isOpen}
        onClose={() => closeAppModal()}
      >
        <AddKitchenForm handleClose={closeAppModal} handleAddKitchen={handleAddKitchen} />
      </dialog>
    </div>
  );
};


const AddKitchenModal: React.FC<AddKitchenModalProps> = (props) => {
  var { isOpen, closeAppModal } = props
  const { isLoading, addKitchenSpace } =  useKitchenHook()
  if (isLoading){
    return (
      <LoadingScreen />
    )
  }
  const handleAddKitchen = (kitchen: DSCommunitySchema | {}) => {
    addKitchenSpace(kitchen)
    closeAppModal();
  }

  return (
    <div
      className={` inset-0 ${isOpen ? "block" : "hidden"} w-full `}
    >
      <div className="fixed inset-0 bg-white opacity-90" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="add-kitchen-modal"
        className="absolute z-50 top-20 p-4 rounded-md shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] md:w-[1158px} ml-14 md:mx-36"
        open={isOpen}
        onClose={() => closeAppModal()}
      >
        <AddKitchenForm handleClose={closeAppModal} handleAddKitchen={handleAddKitchen} />
      </dialog>
    </div>
  );
};


type AddDiscountModalProps = ModalProps & {
  currentResource: ResourceSchema
  handleAddDiscount: (discount: DiscountSchema) => void
  closeAppModal: () => void
}

export const AddDiscountModal: React.FC<AddDiscountModalProps> = (props) => {
  var { isOpen, currentResource, handleAddDiscount, closeAppModal } = props
  const { isLoading } = useResourceHook({resourceId: currentResource?.id as string})


  if (isLoading){
    return (
      <LoadingScreen bgColor="white" height="h-auto" />
    )
  }
  
  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="add-discount-modal"
        className="z-50 w-full max-w-lg md:max-w-2xl max-h-[95vh] bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
        <div className="overflow-y-auto flex-1 p-4">
          <AddDiscountForm resource={currentResource} handleClose={closeAppModal} handleAddDiscount={handleAddDiscount} />
        </div>
      </dialog>
    </div>
  )
}


type AddFeeModalProps = ModalProps & {
  resource?: ResourceSchema
  closeAppModal: () => void;
  handleAddFee: (fee: FeeSchema) => void;
}

export const AddFeeModal: React.FC<AddFeeModalProps> = (props) => {
  var { isOpen, resource, closeAppModal, handleAddFee } = props


  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="add-fee-modal"
        className="z-50 w-full max-w-lg md:max-w-2xl max-h-[95vh] bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
        <div className="overflow-y-auto flex-1 p-4">
          <AddFeeForm resource={resource} handleClose={closeAppModal} handleAddFee={handleAddFee} />
        </div>
      </dialog>
    </div>
  );
}

type AddPlanModalProps = ModalProps & {
  resource?: ResourceSchema
  isDuplicate: {existingPlan: PlanSchema, checked: boolean}
  closeAppModal: () => void;
}

const AddPlanModal: React.FC<AddPlanModalProps> = (props) => {
  var { isOpen, resource, isDuplicate, closeAppModal } = props
  const { communityId, authUser } = useAuthState()
  const { accountData } = useGetConnectedAccount(communityId as string, authUser?.username as string)
  const chargesEnabled = (accountData && accountData?.charges_enabled) ? true : false
  const { isLoading, addCommunityPlan, isError } = useAddCommunityPlan(communityId as string)

  // Hooks must run before any conditional early return, otherwise a mid-submit
  // isLoading flip renders fewer hooks than the previous render (React crash:
  // "Rendered fewer hooks than expected").
  const handleAddPlan = useCallback(async (plan: PlanSchema) => {
    const success = await addCommunityPlan(plan)
    if (isError || !success){
      toast.error("An error occurred while adding the plan. Please try again.");
    }else{
      toast.success("Plan added successfully!");
    }
    closeAppModal();
  }, [addCommunityPlan, isError, closeAppModal])

  if (isLoading){
    return (
      <LoadingScreen bgColor="white" height="h-auto" />
    )
  }

  return (
  <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
    <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
    <dialog
      data-testid="add-plan-modal"
      className="z-50 w-full max-w-lg md:max-w-2xl max-h-[95vh] bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
      open={isOpen}
      onClose={() => closeAppModal()}
      style={{ margin: 0 }}
    >
      <div className="overflow-y-auto flex-1 p-4">
        {
          chargesEnabled ? (
            <AddPlanForm communityId={communityId as string} isDuplicate={isDuplicate} resource={resource} handleClose={closeAppModal} handleAddPlan={handleAddPlan} />
          ) : (
            <GoToPaymentsPageView isOpen={isOpen} closeAppModal={closeAppModal} />
          )
        }
      </div>
    </dialog>
  </div>
  );
}

type EditPlanModalProps = ModalProps & {
  resource?: ResourceSchema
  existingPlan: PlanSchema
  handleEditPlan: (planId: string, plan: PlanSchema) => void
  closeAppModal: () => void;
}

export const EditPlanModal: React.FC<EditPlanModalProps> = (props) => {
  var { isOpen, resource, existingPlan, handleEditPlan, closeAppModal } = props
  const { communityId } = useAuthState()

  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="edit-resource-plan-modal"
        className="z-50 w-full max-w-lg md:max-w-2xl max-h-[95vh] bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
        <div className="overflow-y-auto flex-1 p-4">
          <EditPlanForm communityId={communityId as string} existingPlan={existingPlan} resource={resource} handleClose={closeAppModal} handleEditPlan={handleEditPlan} />
        </div>
      </dialog>
    </div>
  );
}

type AddResourcePlanModalProps = ModalProps & {
  resource?: ResourceSchema
  closeAppModal: () => void;
  isDuplicate: {existingPlan: ResourcePlanSchema, checked: boolean}
}


export const AddResourcePlanModal: React.FC<AddResourcePlanModalProps> = (props) => {
  var { isOpen, resource, isDuplicate, closeAppModal } = props
  const { isLoading, addPlanForResource } = useResourceHook({ resourceId: resource?.id as string });

  const { communityId, authUser } = useAuthState()
  const { accountData } = useGetConnectedAccount(communityId as string, authUser?.username as string)

  // Only take over the screen with a loader while this modal is actually open.
  // The modal stays mounted, and `isLoading` reflects ALL resource mutations, so
  // gating on isLoading alone flashed a full-screen loader during unrelated edits.
  if (isOpen && isLoading){
    return (
      <LoadingScreen bgColor="white" height="h-auto" />
    )
  }
  const chargesEnabled = (accountData && accountData?.charges_enabled) ? true : false

  const handleAddPlan = async (plan: ResourcePlanSchema) => {
    if(plan !== undefined){
      const success = await addPlanForResource(resource?.id as string, plan)
      if (!success){
        toast.error("An error occurred while adding the resource plan. Please try again.");
      }else{
        toast.success("Resource plan added successfully!");
      }
    }

    closeAppModal();
  }

  return (
  <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
    <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
    <dialog
      data-testid="add-resource-plan-modal"
      className="z-50 w-full max-w-lg md:max-w-2xl max-h-[95vh] bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
      open={isOpen}
      onClose={() => closeAppModal()}
      style={{ margin: 0 }}
    >
      {chargesEnabled ? (
        <div className="overflow-y-auto flex-1 p-4">
          <AddResourcePlanForm isDuplicate={isDuplicate} resource={resource} resourceType={resource?.resource_type} handleClose={closeAppModal} handleAddPlan={handleAddPlan} />
        </div>
        ) : (
          <GoToPaymentsPageView isOpen={isOpen} closeAppModal={closeAppModal} />
        )
      }
    </dialog>
  </div>
  );
}


const GoToPaymentsPageView: React.FC<ModalProps & {closeAppModal: () => void}> = (props) => {
  const navigate = useNavigate()
  var { isOpen, closeAppModal } = props
  
  const handleGoToPayments = () => {
    navigate('/payments')
    closeAppModal()
  }
  
  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="go-to-payments-page-modal"
        className="z-50 w-full max-w-lg md:max-w-2xl max-h-[95vh] bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
        <div className="overflow-y-auto flex-1 p-6">
          <div className="flex flex-col items-center text-center space-y-6">
            {/* Warning Icon */}
            <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            
            {/* Title */}
            <div className="space-y-2">
              <h2 className="text-xl font-bold text-gray-900 font-raleway">
                Payment Setup Required
              </h2>
              <p className="text-gray-600 font-open-sans text-md">
                Complete your payment account setup to continue
              </p>
            </div>
            
            {/* Warning Message */}
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 w-full">
              <div className="flex items-start space-x-3">
                <svg className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
                <div className="text-[13px] text-amber-800">
                  <p className="font-semibold mb-1 text-[14px] font-raleway">Action Cannot Be Completed</p>
                  <p className="text-[13px] font-open-sans">You need to set up your payment account before creating new tiers or plans. This ensures secure payment processing for your community.</p>
                </div>
              </div>
            </div>
            
            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 w-full max-w-md">
              <button
                onClick={handleGoToPayments}
                className="flex-1 bg-primary-400 hover:bg-primary-300 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center space-x-2"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                </svg>
                <span className="text-white text-[14px] font-raleway">Go to Payments Page</span>
              </button>
              
              <button
                onClick={closeAppModal}
                className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center space-x-2"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                <span className="text-gray-700 text-[14px] font-raleway">Cancel</span>
              </button>
            </div>
            
            {/* Additional Info */}
            <div className="text-sm text-gray-500 max-w-md font-open-sans">
              <p>Once your payment account is set up, you'll be able to create membership tiers or booking plans for your community.</p>
            </div>
          </div>
        </div>
      </dialog>
    </div>
  )
}

type EditResourcePlanModalProps = {
  resource: ResourceSchema
  isOpen: boolean
  existingPlan: ResourcePlanSchema
  handleEditPlan: (planId: string, plan: ResourcePlanSchema) => void
  closeAppModal: () => void
}

export const EditResourcePlanModal: React.FC<EditResourcePlanModalProps> = ({resource, isOpen, existingPlan, handleEditPlan, closeAppModal}) => {

  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="edit-resource-plan-modal"
        className="z-50 w-full max-w-lg md:max-w-2xl max-h-[95vh] bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
        <div className="overflow-y-auto flex-1 p-4">
          <EditResourcePlanForm resource={resource} existingPlan={existingPlan} handleClose={closeAppModal} handleEditPlan={handleEditPlan} />
        </div>
      </dialog>
    </div>
  )
}


type AddRequirementProps = ModalProps & {
  closeAppModal: () => void;
  handleAddCustomRequirement: (req: RequirementSchema) => void
}

const AddRequirementModal: React.FC<AddRequirementProps> = (props) => {
  var { isOpen, closeAppModal, handleAddCustomRequirement } = props
  // const { isLoading, addKitchenRequirement} = useKitchenHook();
  // if (isLoading){
  //   return (
  //     <LoadingScreen />
  //   )
  // }
  const handleAddRequirement = (req: RequirementSchema| {}) => {
    if(req !== undefined){
      // addKitchenRequirement(req)
      handleAddCustomRequirement(req)
    }
    closeAppModal();
  }

  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="add-custom-requirement"
        className="z-50 w-full max-w-lg md:max-w-2xl max-h-[95vh] bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
        <div className="overflow-y-auto flex-1 p-4">
          <AddRequirementForm handleClose={closeAppModal} handleAddRequirement={handleAddRequirement} />
        </div>
      </dialog>
    </div>
  );
}


// type AddInventoryModalProps = ModalProps & {
//   kitchen?: KitchenSpaceSchema
//   closeAppModal: () => void;
// }

// const AddInventoryModal: React.FC<AddInventoryModalProps> = (props) => {
//   var { isOpen, closeAppModal } = props
//   const { isLoadingInventory, addInventoryItem} = useAddInventory();
//   if (isLoadingInventory){
//     return (
//       <LoadingScreen />
//     )
//   }
//   const handleAddInventory = (inventory: InventorySchema) => {
//     if(inventory !== undefined){addInventoryItem(inventory)}

//     closeAppModal();
//   }

//   return (
//     <div
//       className={`inset-0 ${isOpen ? "block" : "hidden"}`}
//     >
//       <div className="fixed inset-0 bg-white opacity-90" onClick={() => closeAppModal()}></div>

//       <dialog
//         data-testid="add-kitchen-modal"
//         className="fixed z-50 top-20 bg-[#EEE] px-4 rounded-md shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] md:w-1/4 "
//         open={isOpen}
//         onClose={() => closeAppModal()}
//       >
//         <AddInventoryForm handleClose={closeAppModal} handleAddInventory={handleAddInventory} />
//       </dialog>
//     </div>
//   );
// }

// TODO: Add reservation modal
type AddReservationModalProps = ModalProps & {
  closeAppModal: () => void;
  bookings: ResourceBookingSchema[];
  resourceId: string
}

export const AddReservationModal: React.FC<AddReservationModalProps> = (props) => {
  var { isOpen, closeAppModal, resourceId } = props
  return (

    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start h-full justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="add-reservation-modal"
        className="z-50 w-full max-w-lg h-full md:max-w-2xl bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >

        <div className="overflow-y-auto flex-1 p-4 ">
          <span onClick={closeAppModal} className="ml-auto w-full flex cursor-pointer">
            <Cancel className="text-[#A1A1A1] hover:text-[#777] h-[18px] w-[18px] ml-auto" />
          </span>
          <div className="overflow-y-auto flex-1">
            <AddReservationForm isOpen={isOpen} handleClose={closeAppModal} resourceId={resourceId} />
          </div>
        </div>
      </dialog>
    </div>
    // <div
    //   className={`inset-0 ${isOpen ? "block" : "hidden"}`}
    // >
    //   <div className="fixed inset-0 bg-white opacity-90" onClick={() => closeAppModal()}></div>

    //   <dialog
    //     data-testid="add-kitchen-modal"
    //     className="z-50 top-20 bg-[#EEE] p-4 rounded-md shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] w-fit"
    //     open={isOpen}
    //     onClose={() => closeAppModal()}
    //   >
    //     <AddReservationForm isOpen={isOpen} handleClose={closeAppModal} />
    //   </dialog> 
    // </div>
  );
};



type AddMemberFormModalProps = ModalProps & {
  closeAppModal: () => void;
};

const AddMemberFormModal: React.FC<AddMemberFormModalProps> = (props) => {
  var { isOpen, closeAppModal } = props
  const handleAddMember = (kitchen: DSCommunitySchema | {}) => {
    closeAppModal();
  }

  return (
    <div
      className={` inset-0 ${isOpen ? "block" : "hidden"}`}
    >
      <div className="fixed inset-0 bg-white opacity-90" onClick={() => closeAppModal()}></div>

      <dialog
        data-testid="add-kitchen-modal"
        className="z-50 top-20 bg-back-400 p-4 rounded-md shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] md:w-[1158px}"
        open={isOpen}
        onClose={() => closeAppModal()}
      >
        <AddMemberForm isOpen={isOpen} handleClose={closeAppModal} handleAddMember={handleAddMember} />
      </dialog>
    </div>
  );
};



type NewMessageModalProps = ModalProps & {
  username?: string
  closeAppModal: () => void;
};

const NewMessageModal: React.FC<NewMessageModalProps> = (props) => {
  var { isOpen, username, closeAppModal } = props

  return (
    <PortalDialogShell isOpen={isOpen} testId="add-message-modal" onClose={closeAppModal} panelClassName="w-full max-w-lg md:max-w-xl max-h-[90vh]">
      <div className="overflow-y-auto flex-1">
        <NewMessageForm username={username || ''} handleClose={closeAppModal} />
      </div>
    </PortalDialogShell>
  );
};


type AddResourceModalProps = ModalProps & {
  resourceType: ResourceType ;
  handleAddResource: (resource: ResourceSchema) => void
  closeAppModal: () => void;
};

export const AddResourceModal: React.FC<AddResourceModalProps> = (props) => {
  let { isOpen, resourceType, handleAddResource, closeAppModal } = props

  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="add-resource-modal"
        className="z-50 w-full max-w-lg md:max-w-2xl max-h-[95vh] bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
        <div className="overflow-y-auto flex-1 p-4">
          <span onClick={closeAppModal} className="ml-auto w-full flex cursor-pointer">
              <Cancel className="text-[#A1A1A1] hover:text-[#777] h-[18px] w-[18px] ml-auto" />
          </span>
          <AddResourceForm resourceType={resourceType} handleClose={closeAppModal} handleAddResource={handleAddResource} />
        </div>
      </dialog>
    </div>
  );
};


type InviteTeamMemberModalProps = ModalProps & {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  closeAppModal: () => void;
  setShowInviteModal: React.Dispatch<React.SetStateAction<boolean>>
  showSuccessModal: boolean
  setShowSuccessModal: React.Dispatch<React.SetStateAction<boolean>>
};

export const InviteTeamMemberModal: React.FC<InviteTeamMemberModalProps> = (props) => {
  let { isOpen, showSuccessModal,setIsOpen, setShowSuccessModal, closeAppModal } = props

  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="add-resource-modal"
        className="z-50 w-full max-w-lg md:max-w-xl max-h-[95vh] bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
        <div className="overflow-y-auto flex-1 p-4">
          <span onClick={closeAppModal} className="ml-auto w-full flex cursor-pointer">
              <Cancel className="text-[#A1A1A1] hover:text-[#777] h-[18px] w-[18px] ml-auto" />
          </span>
          <div className="mx-auto">
            <InviteTeamMemberForm 
              setShowInviteModal={setIsOpen}
              showSuccessModal={showSuccessModal}
              setShowSuccessModal={setShowSuccessModal}
            />
          </div>
        </div>
      </dialog>
    </div>
  );
};



type AddProductModalProps = ModalProps & {
  resourceType: ResourceType ;
  resourceId: string
  setCurrentInventoryList: React.Dispatch<React.SetStateAction<InventorySchema[]>> | React.Dispatch<React.SetStateAction<TrainingInventorySchema[]>>
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  // handleReloadResource: () => void
  closeAppModal: () => void;
};

export const AddProductModal: React.FC<AddProductModalProps> = (props) => {
  let { isOpen, resourceType, resourceId, setIsOpen, setCurrentInventoryList, closeAppModal } = props
  const { getResourceIconData } = useLoadResourceOptions()
  const resourceIconData = getResourceIconData(resourceType)

  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="add-resource-modal"
        className="z-50 flex max-h-[95vh] w-full max-w-lg flex-col overflow-hidden rounded-xl bg-[#fff] shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] md:max-w-2xl relative"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
        <div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
          <AddProductForm 
            resourceType={resourceType} 
            resourceId={resourceId}
            resourceCategory={resourceIconData.name} 
            setCurrentInventoryList={setCurrentInventoryList} 
            setIsAddingProduct={setIsOpen}
            isOpen={isOpen}
            // handleReloadResource={handleReloadResource}
            isModal={true}
          />
        </div>
      </dialog>
    </div>
  );
};

type UpdateProductModalProps = ModalProps & {
  resourceType: ResourceType ;
  resourceId: string
  setCurrentInventoryList: React.Dispatch<React.SetStateAction<InventorySchema[]>> | React.Dispatch<React.SetStateAction<TrainingInventorySchema[]>>
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  // handleReloadResource: () => void
  closeAppModal: () => void;
  itemId: string
};

export const UpdateProductModal: React.FC<UpdateProductModalProps> = (props) => {
  let { isOpen, resourceType, resourceId, setIsOpen, setCurrentInventoryList, closeAppModal, itemId } = props
  const { getResourceIconData } = useLoadResourceOptions()
  const resourceIconData = getResourceIconData(resourceType)

  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="add-resource-modal"
        className="z-50 flex max-h-[95vh] w-full max-w-lg flex-col overflow-hidden rounded-xl bg-[#fff] shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] md:max-w-2xl relative"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
        <div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
          <UpdateProductForm 
            resourceType={resourceType} 
            resourceId={resourceId}
            resourceCategory={resourceIconData.name} 
            setCurrentInventoryList={setCurrentInventoryList} 
            setIsAddingProduct={setIsOpen}
            // handleReloadResource={handleReloadResource}
            isModal={true}
            itemId={itemId}
          />
        </div>
      </dialog>
    </div>
  );
};


type DeleteConfirmationModalProps = ModalProps & {
  closeDeleteModal: () => void;
  handleDelete: (dataId: string) => void
  dataName: string
  data: any;
};

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = (props) => {
  let { isOpen, data, dataName, closeDeleteModal, handleDelete } = props;
  return (

    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeDeleteModal()}></div>
      <dialog
        data-testid="add-resource-modal"
        className="z-50 w-full max-w-lg md:max-w-2xl max-h-[95vh] bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={() => closeDeleteModal()}
        style={{ margin: 0 }}
      >
        <div className="overflow-y-auto flex-1 p-4">
          <span onClick={closeDeleteModal} className="ml-auto w-full flex cursor-pointer">
              <Cancel className="text-[#A1A1A1] hover:text-[#777] h-[18px] w-[18px] ml-auto" />
          </span>
          <div className="w-full mx-auto">
            <DeleteConfirmationForm
              data={data}
              dataName={dataName}
              handleClose={() => closeDeleteModal()}
              handleDelete={handleDelete}
            />
          </div>
        </div>
      </dialog>
    </div>
  );
};




type ConfirmationModalProps = ModalProps & {
  message: string
  closeModal: () => void;
};

export const ConfirmationModal: React.FC<ConfirmationModalProps> = (props) => {
  let { isOpen , message, closeModal } = props;
  // const [isConfirmBoxOpen, toggleConfirmBox] = useState<boolean>(isOpen)
  return (
    <div
      className={` inset-0 ${isOpen ? "block" : "hidden"} flex items-center justify-center`}
    >
      <div className="fixed inset-0 bg-white opacity-90 z-50"></div>
      <dialog
        data-testid="delete-data-modal"
        className="z-50 top-20 w-[300px] rounded-[32px] h-auto bg-[#fff] p-4 px-1 shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)]"
        open={isOpen}
        onClose={() => closeModal()}
      >
        <div className="w-11/12 mx-auto font-raleway text-[16px] text-[#333] font-medium">
          <CheckCircle className="text-[#0F973D]" /> &nbsp;
          {capitalizeWords(message)}
        </div>
      </dialog>
    </div>
  );
};

// type InformationModalProps = ModalProps & {
//   closeInfoModal: () => void;
//   kitchen: DSCommunitySchema;
// };

// const InformationModal: React.FC<InformationModalProps> = (props) => {
//   let { isOpen, closeInfoModal, kitchen } = props;
//   return (
//     <Dialog
//       fullWidth
//       open={isOpen ? true : false}
//       onClose={() => closeInfoModal()}
//     >
//       <div className="grid">
//         <div className="grid">
//           <KitchenDetails kitchen={kitchen} />
//         </div>
//       </div>
//     </Dialog>
//   );
// };

type AddSelfServiceProps = ModalProps & {
  closeAppModal: () => void;
};

export const AddSelfServiceModal: React.FC<AddSelfServiceProps> = (props) => {
  let { isOpen, closeAppModal } = props;

  const handleSubmit = async (formData: any) => {
    // TODO: Implement venue creation logic here
    // console.log('Form submitted:', formData);
    closeAppModal();
  };


  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="add-self-service-modal"
        className="z-50 w-full max-w-lg md:max-w-2xl max-h-[95vh] bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
        <div className="overflow-y-auto flex-1 p-4">
          <NewSelfServiceForm handleClose={closeAppModal} handleSubmit={handleSubmit} />
        </div>
      </dialog>
    </div>
  );
};

type EditSelfServiceModalProps = ModalProps & {
  closeAppModal: () => void;
  initialData?: SelfServiceDetailsSchema;
  onSave: (formData: SelfServiceDetailsSchema) => void;
};

export const EditSelfServiceModal: React.FC<EditSelfServiceModalProps> = (props) => {
  let { isOpen, closeAppModal, initialData, onSave } = props;

  const handleSubmit = async (formData: SelfServiceDetailsSchema) => {
    onSave(formData);
    closeAppModal();
  };


  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="edit-self-service-modal"
        className="z-50 w-full max-w-lg md:max-w-2xl max-h-[95vh] bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
        <div className="overflow-y-auto flex-1 p-4">
          <EditSelfServiceForm 
            handleClose={closeAppModal} 
            handleSubmit={handleSubmit} 
            initialData={initialData}
          />
        </div>
      </dialog>
    </div>
  );
};


type SetExpirationModalProps = ModalProps & {
  closeAppModal: () => void;
  handleSetExpiration: (type: string, value: number) => void;
  handleRemoveExpiration?: () => void;
};

export const SetExpirationModal: React.FC<SetExpirationModalProps> = (props) => {
  const { isOpen, closeAppModal, handleSetExpiration, handleRemoveExpiration } = props;

  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-center p-6`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="edit-expiration-modal"
        className="z-50 w-full max-w-lg md:max-w-2xl max-h-[95vh] bg-[#fff] relative rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
        <div className="overflow-y-auto flex-1 p-4">
          <div className="w-11/12 max-w-2xl mx-auto p-4">
            <div className="flex flex-row items-center mb-4">
              <CalendarToday className="mr-2 my-auto text-primary-300" style={{ fontSize: 15 }} />
              <h2 className="text-lg font-semibold my-auto">Set Expiration</h2>
            </div>
            <div className="flex flex-row items-center mb-4 w-full">
              <select id="exp-type" className="h-[52px] border-[1px] border-[#E9E9E9] rounded-md px-2 py-1 mr-2 w-4/12" defaultValue="days">
                <option value="days">Days</option>
                <option value="weeks">Weeks</option>
                <option value="months">Months</option>
                <option value="years">Years</option>
              </select>
              <input id="exp-value" type="number" min="1" className="h-[52px] border-[1px] border-[#E9E9E9] rounded-md px-2 py-1 w-8/12" defaultValue={1} />
            </div>
            {handleRemoveExpiration && (
              <div className="flex flex-row items-center mb-4 w-full">
                <p className="text-sm text-primary-400 cursor-pointer" onClick={handleRemoveExpiration}>Remove Expiration</p>
              </div>
            )}
            <div className="flex flex-row justify-end gap-2 w-full">
              <button className="h-[43px] px-4 py-2 rounded-md bg-white border-[1px] border-[#E9E9E9] hover:bg-gray-200 w-1/2 font-semibold" onClick={closeAppModal}>Cancel</button>
              <button
                className="h-[43px] px-4 py-2 rounded-md bg-primary-200 hover:bg-primary-300 text-white w-1/2 font-semibold"
                onClick={() => {
                  const type = (document.getElementById('exp-type') as HTMLSelectElement).value;
                  const value = parseInt((document.getElementById('exp-value') as HTMLInputElement).value, 10);
                  if (value >= 0) handleSetExpiration(type, value);
                }}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </dialog>
    </div>
  );
};

type RequestDetailsModalProps = ModalProps & {
  closeAppModal: () => void;
  request: ResourceBookingSchema
  allResourceRequests: ResourceBookingSchema[]
}

export const RequestDetailsModal: React.FC<RequestDetailsModalProps> = (props) => {
  var { isOpen, request, allResourceRequests, closeAppModal } = props

  return (
    <PortalDialogShell isOpen={isOpen} testId="view-request-modal" onClose={closeAppModal}>
      <div className="overflow-y-auto flex-1 p-4">
        <RequestDetails request={request} allResourceRequests={allResourceRequests} handleClose={closeAppModal} />
      </div>
    </PortalDialogShell>
  );
}

type InventoryDetailsModalProps = ModalProps & {
  inventory?: InventorySchema | null
  resourceDetails: ResourceSchema
  closeAppModal: () => void
}

export const InventoryDetailsModal: React.FC<InventoryDetailsModalProps> = (props) => {
  const { isOpen, inventory, resourceDetails, closeAppModal } = props;

  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? "flex" : "hidden"} items-start justify-end`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => closeAppModal()}></div>
      <dialog
        data-testid="inventory-details-modal"
        className="z-50 w-full max-w-xl md:max-w-2xl h-screen bg-[#fff] relative rounded-none md:rounded-xs shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] overflow-hidden flex flex-col md:mr-6 md:mt-6"
        open={isOpen}
        onClose={() => closeAppModal()}
        style={{ margin: 0 }}
      >
        <div className="flex min-h-0 flex-1 flex-col">
          <div className="flex items-start justify-between border-b border-inventory-border px-5 py-4">
            <p className="font-raleway text-inventory-h6 font-bold text-inventory-primary">
              {inventory?.item_name || "Inventory Item"}
            </p>
            <button
              type="button"
              onClick={closeAppModal}
              className="flex h-9 w-9 items-center justify-center rounded-full border border-inventory-border text-inventory-primary/50 hover:bg-inventory-surface-muted"
              aria-label="Close"
              data-testid="inventory-details-close"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          <InventoryItemDetails inventory={inventory} resourceDetails={resourceDetails} />
        </div>
      </dialog>
    </div>
  );
};

export { 
  AddKitchenModal, DeleteConfirmationModal, 
  // AddInventoryModal,
  NewMessageModal, AddMemberFormModal, DefaultModal, 
  AddPlanModal,AddRequirementModal, AddCredentialModal 
};
